import React from 'react'
import { useRecoilState } from 'recoil'
import { pageState } from '../../../../../src/atoms/PageAtom'
import { pastPageState } from '../../../../../src/atoms/PastPageAtom'

import ArtistIcon from '../../../../../src/assets/images/icons/user-circle.svg'

type Props = {
  artist: Artist
}
type Artist = {
  public_id: string
  display_name: string
  comment: string
  gift_detail: string
  icon_uri: string
  music_count: number
  market_music_count: number
  generative_count: number
}

function HomeArtist(props: Props) {
  const [, setPage] = useRecoilState(pageState)
  const [, setPastPage] = useRecoilState(pastPageState)

  return (
    <button
      className="artist"
      onClick={() => {
        setPastPage('home')
        setPage(`artists/${props.artist.public_id}`)
      }}
    >
      <div
        className="image"
        style={{
          backgroundImage: `url(${
            props.artist.icon_uri ? props.artist.icon_uri : ArtistIcon
          })`,
        }}
      ></div>
      <div className="datum">
        <h3 className="name">{props.artist.display_name}</h3>
        <div className="data">
          <p className="data-ttl">掲載楽曲数</p>
          <p className="data-txt">{props.artist.music_count}曲</p>
        </div>
        <div className="data">
          <p className="data-ttl">販売楽曲数</p>
          <p className="data-txt">{props.artist.market_music_count}曲</p>
        </div>
        <div className="data">
          <p className="data-ttl">ジェネラティブ数</p>
          <p className="data-txt">{props.artist.generative_count}件</p>
        </div>
      </div>
    </button>
  )
}

export default HomeArtist
